module.exports = __webpack_public_path__ + "img/correct.1c71a6aa.png";